import { FC } from 'react';

export const FieldCell: FC<{
  identifier: any;
  value: any;
  bgColor?: string;
}> = ({ identifier, value, bgColor }) => {
  return (
    <div
      className={`border rounded break-all border-off-navy text-xs text-navy w-fit basis-5 grow-0 my-0.5 px-1 py-0 ${
        bgColor ?? ''
      }`}
    >
      {identifier}: {value}
    </div>
  );
};
